import React from 'react';

import { WidgetProps } from 'app/components/Visualization/CDashboard/types';

import {
  TotalEntities,
  Policies,
  PolicyExceptions,
  ResourceExceptions,
  PassedChecks,
} from './ComplianceSummary';

const styles = { root: { pb: 0 } };
export const availableWidgets1: { [key: string]: WidgetProps } = {
  policies: {
    flex: true,
    components: {
      content: <Policies />,
    },
    styles,
    className: 'compliance_summary',
  },
  totalEntities: {
    flex: true,
    components: {
      content: <TotalEntities />,
    },
    styles,
    className: 'compliance_summary',
  },
  policyExceptions: {
    flex: true,
    components: {
      content: <PolicyExceptions />,
    },
    styles,
    className: 'compliance_summary',
  },
  resourceExceptions: {
    flex: true,
    components: {
      content: <ResourceExceptions />,
    },
    styles,
    className: 'compliance_summary',
  },
  passedChecks: {
    flex: true,
    components: {
      content: <PassedChecks />,
    },
    styles,
    className: 'compliance_summary',
  },
};
